/**
 * Função de formatação e conversão de distancias
 * @param {*} d Distancia calculada em metros
 * @param {('m'|'km'|'auto')} unit Unidade de medida podendo ser 'm', 'km'
 */
export const formatDistance = function (d, unit, returnUnit = true) {
  let distanceInMeters,
    prefix = null;

  /**
   * Se adicionarmos algum prefixo como
   * 'Área' ou 'Per.:' de perímetro o código retira
   * só o número para cálculos e mantém o prefixo na
   * exibição
   */
  if (typeof d === 'string') {
    distanceInMeters = parseFloat(d.match(/\d+\.\d+|\d+/g, ''));
    prefix = d.split(/\d+\.\d+|\d+/)[0];
  } else {
    distanceInMeters = d;
  }

  let numberFormat = new Intl.NumberFormat('pt-BR', {
    maximumFractionDigits: 2,
  });
  if (unit === 'auto') {
    if (distanceInMeters > 1000) {
      distanceInMeters = distanceInMeters / 1000;
      unit = 'km';
    } else {
      unit = 'm';
    }
  } else {
    if (unit === 'km') {
      distanceInMeters = distanceInMeters / 1000;
      unit = 'km';
    }
  }

  return `${prefix ? `${prefix} ` : ''}${numberFormat.format(
    distanceInMeters.toFixed(2)
  )} ${returnUnit && unit}`;
};

/**
 * Função de formatação e conversão de area
 * @param {*} a Area calculada em metros quadrados
 * @param {('m', 'km', 'ha')} unit Unidade de medida podendo ser 'm', 'km', 'ha'
 */
export const formatArea = function (a, unit, returnUnit = true) {
  let areaInSquareMeters,
    prefix = null;

  /**
   * Se adicionarmos algum prefixo como
   * 'Área' ou 'Per.:' de perímetro o código retira
   * só o número para cálculos e mantém o prefixo na
   * exibição
   */
  if (typeof a === 'string') {
    areaInSquareMeters = parseFloat(a.match(/\d+\.\d+|\d+/g, ''));
    prefix = a.split(/\d+\.\d+|\d+/)[0];
  } else {
    areaInSquareMeters = a;
  }

  let numberFormat = new Intl.NumberFormat('pt-BR', {
    maximumFractionDigits: 2,
  });
  if (unit === 'm') {
    unit = 'm²';
  } else if (unit === 'km') {
    areaInSquareMeters = areaInSquareMeters / 1000000;
    unit = 'km²';
  } else if (unit === 'ha') {
    areaInSquareMeters = areaInSquareMeters / 10000;
    unit = 'ha';
  }

  return `${prefix ? `${prefix} ` : ''}${numberFormat.format(
    areaInSquareMeters
  )} ${returnUnit && unit}`;
};
